import {
  faBuilding,
  faEnvelope,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomerInfo from 'components/app/e-commerce/customers-details/CustomerInfo';
import Flex from 'components/common/Flex';
import CustomerAddress from 'components/registration/customers-details/CustomerAddress';
import CustomerContact from 'components/registration/customers-details/CustomerContact';
import CustomerDomains from 'components/registration/customers-details/CustomerDomains';
import useApi from 'helpers/api';
import { useFormatDateTime } from 'hooks/useFormatDateTime';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import Tickets from './TicketsCustomer';

const CustomerDetails = () => {
  const { id } = useParams();
  const api = useApi();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const formatDateTime = useFormatDateTime();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCustomer();
  }, []);

  const getCustomer = async () => {
    setIsLoading(true);
    const response = await api.customers.findById(id);
    if (response.userMessage) {
      showErrorNotification(response.userMessage);
      navigate('/registration/customers');
    } else {
      setCustomer(response);
    }
    setIsLoading(false);
  };

  return (
    <>
      {/* <CustomerDetailsHeader data={customer} loading={isLoading} /> */}
      <Row className="g-1">
        <Col xxl={12}>
          <Card>
            <Flex
              className="p-3"
              justifyContent="between"
              alignItems={'center'}
            >
              <Flex alignItems="center">
                <Button
                  variant="falcon-default"
                  as={Link}
                  to={'/registration/customers'}
                  size="sm"
                  className="me-3"
                >
                  <FontAwesomeIcon icon="arrow-left" />
                </Button>
                <h4 className="m-0">
                  <FontAwesomeIcon
                    icon={
                      customer.type === 'JURIDICAL_PERSON' ? faBuilding : faUser
                    }
                    className="me-2"
                  />
                  {customer.name}
                </h4>
              </Flex>

              <Flex direction={'column'}>
                <h6 className="m-0">Criado em</h6>
                <span className="fs-10">
                  {formatDateTime(customer.creationDate)}
                </span>
              </Flex>
            </Flex>
            <Tab.Container defaultActiveKey="basicData">
              <SimpleBar>
                <Card.Header className="p-0">
                  <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="basicData"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon
                          icon="stream"
                          className="text-600 tab-icon"
                        />
                        <h6 className="text-600 mb-0 ms-1">Dados básicos</h6>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="contacts"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon icon="users" className="text-600" />
                        <h6 className="text-600 mb-0 ms-1">Contatos</h6>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="domains"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="text-600"
                        />
                        <h6 className="text-600 mb-0 ms-1">Domínios</h6>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="addresses"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon
                          icon="map-marker-alt"
                          className="text-600"
                        />
                        <h6 className="text-600 mb-0 ms-1">Endereços</h6>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="tickets"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon
                          icon="ticket-alt"
                          className="text-600"
                        />
                        <h6 className="text-600 mb-0 ms-1">Tickets</h6>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Card.Header>
              </SimpleBar>
              <Card.Body className="pb-0">
                <Tab.Content>
                  <Tab.Pane eventKey="basicData">
                    <CustomerInfo
                      loading={isLoading}
                      data={customer}
                      success={response => showSuccessNotification(response)}
                      error={error => {
                        showErrorNotification(error);
                      }}
                    />
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey="users">
                    <CustomerPortalUsers data={customer} />
                  </Tab.Pane> */}
                  <Tab.Pane eventKey="contacts">
                    <CustomerContact data={customer} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="addresses">
                    <CustomerAddress data={customer} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="domains">
                    <CustomerDomains data={customer} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tickets">
                    <Tickets data={customer} />
                  </Tab.Pane>
                </Tab.Content>
              </Card.Body>
            </Tab.Container>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CustomerDetails;
